import { useEffect, useState } from "react"
import { BsArrowLeft, BsPlusCircleFill } from "react-icons/bs"
import { AiOutlineSearch, AiOutlineMail } from "react-icons/ai"
import { LiaExchangeAltSolid } from "react-icons/lia"
import { IoAddCircleSharp, IoChevronDownSharp } from "react-icons/io5"
import { IoMdCloseCircle, IoMdSettings } from "react-icons/io"
import dayjs from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import AddNewItem from "../components/AddNewItem"
import AddNewCustomer from "../components/AddNewCustomer"
import axios from "axios"
import api from "../config/backend"
import { useNavigate, useParams } from "react-router-dom"
import {
    AppBar,
    FormControl,
    FormLabel,
    Grid,
    Tab,
    Tabs,
    TextField,
} from '@mui/material'
import Navigation from "../components/Navigation"
import "./css/CreateInvoiceExternal.css"
import { FaFileInvoice } from "react-icons/fa"
import { toast } from "react-toastify"
import addressit from "addressit"
import { Country, State, City } from "country-state-city"
import { validate } from 'postal-codes-js'
import ManageTax from "../components/ManageTax"
import { SpinnerCircular } from "spinners-react"
import SignatureInput from "../components/SignatureInput"

const CreateInvoiceExternal = () => {
    const [customerFirstname, setCustomerFirstname] = useState("")
    const [customerLastname, setCustomerLastname] = useState("")
    const [customerEmail, setCustomerEmail] = useState("")
    const [customerPhone, setCustomerPhone] = useState("")
    const [customerCompany, setCustomerCompany] = useState("")
    const [tabValue, setTabValue] = useState(0)
    const [taxInputOpen, setTaxInputOpen] = useState(false)
    const [taxSearchInput, setTaxSearchInput] = useState("")
    const [referenceInput, setReferenceInput] = useState("")
    const [invoiceDate, setInvoiceDate] = useState(undefined)
    const [invoiceExpiryDate, setInvoiceExpiryDate] = useState(undefined)
    const [subjectInput, setSubjectInput] = useState("")
    const [invoiceItems, setInvoiceItems] = useState([
        {
            item: "",
            quantity: "1.00",
            rate: "0.00",
            data: undefined
        }
    ])
    const [discount, setDiscount] = useState("0")
    const [calculatedDiscount, setCalculatedDiscount] = useState("0")

    // Discount is percent or amount
    const [discountUnit, setDiscountUnit] = useState("percentage")
    const [adjustmentsText, setAdjustmentsText] = useState("Adjustments")
    const [adjustmentValue, setAdjustmentValue] = useState("0")
    const [subTotal, setSubTotal] = useState("0")
    const [totalAmount, setTotalAmount] = useState("0")
    const [customerNotes, setCustomerNotes] = useState("Thanks for your business.")
    const [addItemsPopupIndex, setAddItemsPopupIndex] = useState(false)
    const [addNewItemPopupOpen, setAddNewItemPopupOpen] = useState(false)
    const [addNewCustomerPopup, setAddNewCustomerPopup] = useState(false)
    const [addManageTaxPopup, setAddManageTaxPopup] = useState(false)
    const [productList, setProductList] = useState([])
    const [filteredProductList, setFilteredProductList] = useState([])
    const [productUpdatedRefresh, setProductUpdatedRefresh] = useState(0)
    const [taxesUpdatedRefresh, setTaxesUpdatedRefresh] = useState(0)
    const [customersList, setCustomersList] = useState([])
    const [filteredCustomersList, setFilteredCustomersList] = useState([])
    const [selectedCustomer, setSelectedCustomer] = useState(undefined)
    const [customersUpdatedRefresh, setCustomersUpdatedRefresh] = useState(0)
    const [invoiceCount, setInvoiceCount] = useState(0)
    const [error, setError] = useState(false)
    const [selectedTax, setSelectedTax] = useState(undefined)
    const [calculatedTax, setCalculatedTax] = useState(0)
    const [taxList, setTaxList] = useState([])
    const [filteredTaxList, setFilteredTaxList] = useState([])
    const [panCard, setPanCard] = useState('')
    const [selectedCurrency, setSelectedCurrency] = useState('currency')
    const [currencyInputOpen, setCurrencyInputOpen] = useState(false)
    const [currencyOptions, setCurrencyOptions] = useState([])
    const [currencySearch, setCurrencySearch] = useState("")
    const [selectedCountry, setSelectedCountry] = useState("Afghanistan")
    const [countryOptions, setCountryOptions] = useState([])
    const [stateOptions, setStateOptions] = useState([])
    const [selectedState, setSelectedState] = useState('state')
    const [completeAddress, setCompleteAddress] = useState("")
    const [street, setStreet] = useState('')
    const [streetone, setStreetOne] = useState('')
    const [city, setCity] = useState('')
    const [zipcode, setZipcode] = useState('')
    const [state, setState] = useState("")
    const [country, setCountry] = useState("")
    const [remarks, setRemarks] = useState("")
    const [loading, setLoading] = useState(false)
    const [signcanvas, setSigncanvas] = useState(false)
    const [signature, setSignature] = useState(undefined)
    const [taxtype, setTaxtype] = useState("tds")
    const [customFields, setCustomFields] = useState([{ fieldname: "", value: "" }])

    const token = localStorage.getItem("_crm__token")
    const endpoint = localStorage.getItem("startpoint")

    const navigate = useNavigate()

    const { identifier } = useParams()

    // const fetchProducts = async () => {
    //     const { data, status } = await axios.post(`${api}/Accounting/fetch-products`, { token })

    //     if (data.success) {
    //         setProductList(data.products)
    //     }
    // }

    // const fetchCustomers = async () => {
    //     const { data, status } = await axios.post(`${api}/Accounting/fetch-customers`, { token })

    //     if (data.success) {
    //         setCustomersList(data.customers)
    //     }
    // }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    const handleCurrencyClick = (option) => {
        setSelectedCurrency(option._id)
        setCurrencyInputOpen(false)
    }

    const fetchInvoiceCount = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/invoice-count`, { token })

        if (data.success) {
            setInvoiceCount(data.count + 1)
        }
    }

    const fetchTaxList = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/fetch-tax`, {
            token, taxtype
        })

        if (data.success) {
            setTaxList(data.taxes)
        }
    }

    const fetchCurrency = async () => {
        try {
            const response = await axios.post(`${api}/Accounting/fetch-currency`, { token })
            const { data } = response

            if (data.success) {
                const indiancurrency = data.currency.find(item => item.code === "INR")
                indiancurrency && setSelectedCurrency(indiancurrency._id)

                setCurrencyOptions(data.currency)
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    const fetchInvoice = async () => {
        let data

        try {
            const response = await axios.get(`${endpoint}/api/Invoice/view/${identifier}`)

            data = response.data
        } catch (error) {
            toast.error(`Failed to connect ${endpoint}`)
            console.error(error)
            return
        }

        if (data) {
            const firstname = data.Invoice_Employee.fname
            const lastname = data.Invoice_Employee.lname

            setCustomerFirstname(firstname)
            lastname && setCustomerLastname(lastname)
            data.Invoice_Consumer.address && setCompleteAddress(data.Invoice_Consumer.address)
            setInvoiceDate(dayjs(data.start_date))
            data.end_date && setInvoiceExpiryDate(dayjs(data.end_date))
            setInvoiceItems([{
                item: `${firstname} ${lastname} (${data.Invoice_Employee.emp_code}) - ${data.Invoice_Employee.Designation.designation_name}`,
                quantity: String(Number(data.billing_hrs).toFixed(2)),
                rate: String(Number(data.hourly_rate).toFixed(2)),
                data: undefined
            }])
            data.Invoice_Consumer.email && setCustomerEmail(data.Invoice_Consumer.email)
            data.Invoice_Client.client_name && setCustomerCompany(data.Invoice_Client.client_name)
        }
        else {
            toast.error("Invalid invoice identifier")
        }
    }

    // send: boolean true - send invoice via e-mail
    const handleCreateInvoice = async (send) => {
        setLoading(send ? "send-invoice" : "create-invoice")
        const { data, status } = await axios.post(`${api}/Accounting/External/create-invoice`, {
            token,
            customerfname: customerFirstname,
            customerlname: customerLastname,
            customeremail: customerEmail,
            customerphone: customerPhone,
            customercompany: customerCompany,
            customerpan: panCard,
            customercurrency: selectedCurrency,
            customeraddress: {
                street,
                streetone,
                city,
                state,
                zipcode,
                country
            },
            customerremarks: remarks,
            customfields: customFields,
            reference: referenceInput,
            invoicedate: invoiceDate,
            expirydate: invoiceExpiryDate,
            subject: subjectInput,
            items: invoiceItems,
            discount: {
                ispercentage: discountUnit === "percentage" ? true : false,
                value: discount
            },
            adjustment: {
                text: adjustmentsText,
                value: adjustmentValue
            },
            taxhash: selectedTax ? selectedTax.hash : undefined,
            signature,
            note: customerNotes
        })

        setLoading(false)

        if (data.success) {
            if (send) {
                const hash = data.invoice.hash

                navigate("/accounting-external/invoice/send/" + hash)
            }
            else {
                toast.success(data.message)
            }
        }
        else {
            setError(data.message)
        }
    }

    useEffect(() => {
        fetchInvoiceCount()
        fetchCurrency()
        fetchInvoice()
    }, [])

    useEffect(() => {
        if (completeAddress) {
            const address = addressit(completeAddress)

            let [street, city, state, country, zip] = ["", "", "", "", ""]

            const states = State.getAllStates()
            const countries = Country.getAllCountries()

            // Find country and zip code form input
            if (address.regions.length) {
                // Find the country
                for (let region of address.regions) {
                    const c = countries.find(item => item.name.toLowerCase() === region.toLowerCase())

                    if (c) {
                        country = c
                        break
                    }
                }

                // Remove country from regions - not required
                // Find the zip code using country code
                if (country) {
                    const index = address.regions.indexOf(country.name)

                    if (index > -1) {
                        address.regions.splice(index, 1)
                    }

                    // Find the zip code
                    for (let region of address.regions) {
                        const z = validate(country.isoCode, region)

                        if (z === true) {
                            zip = region
                            break
                        }
                    }
                }

                // Remove zip code from regions - not required
                if (zip) {
                    const index = address.regions.indexOf(zip)

                    if (index > -1) {
                        address.regions.splice(index, 1)
                    }
                }

                if (country && address.regions.length) {
                    city = address.regions[0]
                }
            }

            if (address.street) {
                street = address.street
            }

            if (address.state) {
                // State is short code
                if (address.state.length <= 4) {
                    const statematch = states.find(item => {
                        if (country) {
                            return (item.isoCode === address.state) && (item.countryCode === country.isoCode)
                        }
                        return item.isoCode === address.state
                    })

                    if (statematch) {
                        state = statematch.name
                    }
                }
                else {
                    state = address.state
                }
            }

            // Unable to parse provided address
            if (country === "" && street === "" && state === "" && city === "" && zip === "") {
                setCity(address.text)
            }
            else {
                country && setCountry(country.name)
                street && setStreet(street)
                state && setState(state)
                city && setCity(city)
                zip && setZipcode(zip)
            }
        }
    }, [completeAddress])

    useEffect(() => {
        fetchTaxList()
    }, [taxesUpdatedRefresh, taxtype])

    // useEffect(() => {
    //     fetchProducts()
    // }, [productUpdatedRefresh])

    // useEffect(() => {
    //     fetchCustomers()
    // }, [customersUpdatedRefresh])

    // Calculate sub total amount
    useEffect(() => {
        let total = 0

        invoiceItems.forEach(item => {
            total += item.quantity * item.rate
        })

        setSubTotal(total)
    }, [invoiceItems])

    // Calculate discount
    useEffect(() => {
        if (discountUnit === "percentage") {
            setCalculatedDiscount((subTotal * discount) / 100)
        }
        else {
            setCalculatedDiscount(discount)
        }
    }, [subTotal, discount, discountUnit])

    // Calculate total amount
    useEffect(() => {
        const total = Number(subTotal) + Number(adjustmentValue) - Number(calculatedDiscount)

        let tax = 0

        if (selectedTax) {
            tax = total * selectedTax.rate / 100
        }

        setCalculatedTax(tax)
        setTotalAmount(total + tax)
    }, [subTotal, adjustmentValue, calculatedDiscount, selectedTax && selectedTax.hash])

    // Filter product list based on input
    useEffect(() => {
        if (addItemsPopupIndex === false) {
            return
        }

        setFilteredProductList(productList.filter(product => {
            const input = invoiceItems[addItemsPopupIndex].item

            return product.productname.toLowerCase().includes(input.toLowerCase())
        }))
    }, [productList, invoiceItems, addItemsPopupIndex])

    // Filter customers list based on search input
    // useEffect(() => {
    //     if (customerFirstname) {
    //         setFilteredCustomersList(customersList.filter(customer => {
    //             const input = customerFirstname.toLowerCase()

    //             let fullname = customer.firstname.toLowerCase()

    //             if (customer.lastname) {
    //                 fullname = fullname + " " + customer.lastname.toLowerCase()
    //             }

    //             if (fullname.includes(input)) {
    //                 return true
    //             }

    //             if (customer.email.toLowerCase().includes(input)) {
    //                 return true
    //             }

    //             return false
    //         }))
    //     }
    //     else {
    //         setFilteredCustomersList(customersList)
    //     }
    // }, [customerFirstname, customersList])

    // Filter tax list based on search input
    useEffect(() => {
        if (taxSearchInput) {
            setFilteredTaxList(taxList.filter(tax => {
                const input = taxSearchInput.toLowerCase()

                if (tax.name.toLowerCase().includes(input) || tax.tax.section.toLowerCase().includes(input)) {
                    return true
                }

                return false
            }))
        }
        else {
            setFilteredTaxList(taxList)
        }
    }, [taxSearchInput, taxList])

    useEffect(() => {
        let timeout

        if (error) {
            timeout = setTimeout(() => {
                setError(undefined)
            }, 4000)
        }

        return () => clearTimeout(timeout)
    }, [error])

    return (
        (
            <div className="_5tya _7zhg">
                {signcanvas ? <SignatureInput setPopup={setSigncanvas} setSignature={setSignature} /> : undefined}
                <ManageTax popup={addManageTaxPopup} setPopup={setAddManageTaxPopup} setTriggerRefresh={setTaxesUpdatedRefresh} taxtype={taxtype} />
                <div>
                    <div className="swishes-mat">
                        <FaFileInvoice />
                        Generate Invoice
                    </div>
                    <div className="soothe-far">
                        <div style={{ color: "#3b70ad", fontSize: "14px", marginBottom: "20px", fontWeight: 600 }}>
                            Customer Details
                        </div>
                        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
                            <div className="module-bag">
                                <TextField value={customerFirstname} onChange={e => setCustomerFirstname(e.target.value)} id="outlined-basic" label="First Name *" variant="outlined" />
                            </div>
                            <div className="module-bag">
                                <TextField value={customerLastname} onChange={e => setCustomerLastname(e.target.value)} id="outlined-basic" label="Last Name" variant="outlined" />
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
                            <div className="module-bag">
                                <TextField disabled={true} value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} id="outlined-basic" label="Email Address *" variant="outlined" />
                            </div>
                            <div className="module-bag">
                                <TextField value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} id="outlined-basic" label="Phone Number" variant="outlined" />
                            </div>
                        </div>
                        <div className="module-bag">
                            <TextField value={customerCompany} onChange={e => setCustomerCompany(e.target.value)} id="outlined-basic" label="Company Name" variant="outlined" />
                        </div>
                        <div className='other-address-remarks'>
                            <AppBar position="static" className="custom-appbar">
                                <Tabs value={tabValue} onChange={handleTabChange}>
                                    <Tab label="Other Details" />
                                    <Tab label="Address" />
                                    <Tab label="Custom Fields" />
                                </Tabs>
                            </AppBar>
                            {tabValue === 0 && (
                                <div>
                                    <div className='pan-currency-content'>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <div className='company-details-list'>
                                                    <TextField onChange={(e) => setPanCard(e.target.value)} id="outlined-basic" label="PAN" variant="outlined" />
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className='company-details-list'>
                                                    <div className="whingy-peep">
                                                        <div className="peep-peep">
                                                            <div
                                                                onClick={() => setCurrencyInputOpen(!currencyInputOpen)}
                                                                className="salients-rap"
                                                            >
                                                                {selectedCurrency && currencyOptions.find(option => option._id === selectedCurrency)?.name || 'Select Currency'}
                                                            </div>
                                                            {currencyInputOpen ? (
                                                                <div onClick={(e) => e.stopPropagation()} className="cirrus-tee">
                                                                    <input
                                                                        placeholder="Search"
                                                                        value={currencySearch}
                                                                        onChange={e => setCurrencySearch(e.target.value)}
                                                                    />
                                                                    <div className="country-scroll">
                                                                        {currencyOptions.filter(item => item.name.toLowerCase().includes(currencySearch.toLowerCase()) || item.code.toLowerCase().includes(currencySearch.toLowerCase())).map((option, index) => (
                                                                            <button
                                                                                key={index}
                                                                                onClick={() => handleCurrencyClick(option)}
                                                                                className="term-button"
                                                                            >
                                                                                {option.code}- {option.name}
                                                                            </button>

                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ) : undefined}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} style={{ marginTop: "3px" }}>
                                            <Grid item xs={4}>
                                                <div className='company-details-list'>
                                                    <TextField value={remarks} onChange={(e) => setRemarks(e.target.value)} id="outlined-basic" label="Remarks" variant="outlined" />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            )}
                            {tabValue === 1 && (
                                <div className="ship-bill">
                                    <div>
                                        <div className='street'>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4}>
                                                    <div className='company-details-list'>
                                                        <TextField value={street} onChange={(e) => setStreet(e.target.value)} id="outlined-basic" label="Street" variant="outlined" />
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className='company-details-list'>
                                                        <TextField value={streetone} onChange={(e) => setStreetOne(e.target.value)} id="outlined-basic" label="Alternate Street" variant="outlined" />
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div className='street'>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4}>
                                                    <div className='company-details-list'>
                                                        <TextField value={city} onChange={(e) => setCity(e.target.value)} id="outlined-basic" label="City" variant="outlined" />
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className='company-details-list'>
                                                        <TextField value={state} onChange={(e) => setState(e.target.value)} id="outlined-basic" label="State" variant="outlined" />
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div className='street'>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4}>
                                                    <div className='company-details-list'>
                                                        <TextField value={country} onChange={(e) => setCountry(e.target.value)} id="outlined-basic" label="Country" variant="outlined" />
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className='company-details-list'>
                                                        <TextField value={zipcode} onChange={(e) => setZipcode(e.target.value)} id="outlined-basic" label="Zip Code" variant="outlined" />
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {tabValue === 2 && (
                                <div className="fishbolt-kaon">
                                    {customFields.map((field, index) => {
                                        return (
                                            <div className="parvo-pod" key={index}>
                                                <TextField
                                                    sx={{ width: "400px" }}
                                                    id="outlined-basic"
                                                    label="Field Name"
                                                    variant="outlined"
                                                    value={field.fieldname}
                                                    onChange={e => setCustomFields(prev => {
                                                        const copy = JSON.parse(JSON.stringify(prev))
                                                        copy[index].fieldname = e.target.value
                                                        return copy
                                                    })}
                                                />
                                                <TextField
                                                    sx={{ width: "400px" }}
                                                    id="outlined-basic"
                                                    label="Field Value"
                                                    variant="outlined"
                                                    value={field.value}
                                                    onChange={e => setCustomFields(prev => {
                                                        const copy = JSON.parse(JSON.stringify(prev))
                                                        copy[index].value = e.target.value
                                                        return copy
                                                    })}
                                                />
                                                {(customFields.length === index + 1) ? (
                                                    <button onClick={() => {
                                                        setCustomFields(prev => {
                                                            return [...prev, { fieldname: "", value: "" }]
                                                        })
                                                    }}>
                                                        +
                                                    </button>
                                                ) : (
                                                    <button className="obtrudes-ref" onClick={() => {
                                                        setCustomFields(prev => {
                                                            const copy = JSON.parse(JSON.stringify(prev))
                                                            copy.splice(index, 1)
                                                            return copy
                                                        })
                                                    }}>
                                                        -
                                                    </button>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>

                        <div style={{ color: "#3b70ad", fontSize: "14px", marginTop: "30px", marginBottom: "20px", fontWeight: 600 }}>
                            Invoice Details
                        </div>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <div className="row">
                                    <div className="whingy-peep">
                                        <span>Invoice</span>
                                        <div className="woolsack-cue">INV-{String(invoiceCount).padStart(6, "0")}</div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <div className='primary-first-name'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Invoice Date *"
                                            value={invoiceDate}
                                            onChange={(newValue) => setInvoiceDate(newValue)}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className='primary-first-name'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Due Date"
                                            value={invoiceExpiryDate}
                                            onChange={(newValue) => setInvoiceExpiryDate(newValue)}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <div className='primary-first-name'>
                                    <TextField value={subjectInput}
                                        onChange={e => setSubjectInput(e.target.value)} placeholder="Let the customer know what the invoice is for" id="outlined-basic" label="Subject" variant="outlined" />
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className='primary-first-name'>
                                    <TextField value={referenceInput} onChange={e => setReferenceInput(e.target.value)} id="outlined-basic" label="Reference" variant="outlined" />
                                </div>
                            </Grid>
                        </Grid>
                        <div className="row">
                            <div className="murphies-nut">
                                <div className="table-header">
                                    <div className="item-details">
                                        ITEM DETAILS
                                    </div>
                                    <div>
                                        ESTIMATED HOURS
                                    </div>
                                    <div>
                                        HOURLY RATE
                                    </div>
                                    <div>
                                        AMOUNT
                                    </div>
                                </div>
                                <div className="table-content">
                                    {invoiceItems.map((item, index) => {
                                        return (
                                            <div key={index} className="table-row">
                                                <div className="item-details">
                                                    <textarea
                                                        className="serif-rags"
                                                        value={item.item}
                                                        onChange={e => setInvoiceItems(prev => {
                                                            const copy = JSON.parse(JSON.stringify(prev))
                                                            copy[index].item = e.target.value

                                                            // Remove the prev data - adds up because of selecting a product
                                                            copy[index].data = undefined
                                                            return copy
                                                        })}
                                                        placeholder="Type or click to select an item."
                                                    />
                                                </div>
                                                <div>
                                                    <input
                                                        className="liftoff-just"
                                                        value={item.quantity}
                                                        onChange={e => setInvoiceItems(prev => {
                                                            const copy = JSON.parse(JSON.stringify(prev))
                                                            copy[index].quantity = e.target.value

                                                            return copy
                                                        })}
                                                    />
                                                </div>
                                                <div>
                                                    <input
                                                        className="liftoff-just"
                                                        value={item.rate}
                                                        onChange={e => setInvoiceItems(prev => {
                                                            const copy = JSON.parse(JSON.stringify(prev))
                                                            copy[index].rate = e.target.value

                                                            return copy
                                                        })}
                                                    />
                                                </div>
                                                <div className="upholder-eyed">
                                                    {(Math.round((item.rate * item.quantity) * 100) / 100).toFixed(2)}
                                                </div>
                                                <div className="hominids-cads" onClick={() => setInvoiceItems(prev => {
                                                    const copy = JSON.parse(JSON.stringify(prev))
                                                    copy.splice(index, 1)

                                                    return copy
                                                })}>
                                                    <IoMdCloseCircle />
                                                </div>
                                            </div>
                                        )
                                    })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="files-skis row">
                            <div className="agitator-ask">
                                <div>
                                    <button className="welsh-cubs" onClick={() => setInvoiceItems(prev => {
                                        const copy = JSON.parse(JSON.stringify(prev))
                                        copy.push({
                                            item: "",
                                            quantity: "1.00",
                                            rate: "0.00",
                                            data: undefined
                                        })
                                        return copy
                                    })}>
                                        <BsPlusCircleFill />
                                        <span>Add another line</span>
                                    </button>
                                </div>
                                <div>
                                    <div>Customer Notes</div>
                                    <textarea
                                        value={customerNotes}
                                        onChange={e => setCustomerNotes(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="adepts-hope">
                                <div className="imitator-doty">
                                    <div className="atheise-heir networks-oak">
                                        <div>
                                            Sub Total
                                        </div>
                                        <div className="icing-bit">

                                        </div>
                                        <div>
                                            {(Math.round(subTotal * 100) / 100).toFixed(2)}
                                        </div>
                                    </div>
                                    {/* <div className="networks-oak">
                                        <div>
                                            Discount
                                        </div>
                                        <div className="jibes-het icing-bit">
                                            <input
                                                value={discount}
                                                onChange={e => setDiscount(e.target.value)}
                                            />
                                            <div className="shallops-onus">
                                                <span>{discountUnit === "percentage" ? "%" : "₹"}</span>
                                                <div className="godetias-doom" onClick={() => setDiscountUnit(prev => {
                                                    return prev === "percentage" ? "amount" : "percentage"
                                                })}>
                                                    <LiaExchangeAltSolid />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            {(Math.round(calculatedDiscount * 100) / 100) > 0 ? "-" : undefined}{(Math.round(calculatedDiscount * 100) / 100).toFixed(2)}
                                        </div>
                                    </div> */}
                                    <div className="networks-oak">
                                        <div>
                                            <input
                                                className="coxalgic-say"
                                                value={adjustmentsText}
                                                onChange={e => setAdjustmentsText(e.target.value)}
                                            />
                                        </div>
                                        <div className="icing-bit">
                                            <input
                                                value={adjustmentValue}
                                                onChange={e => setAdjustmentValue(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            {(Math.round(adjustmentValue * 100) / 100).toFixed(2)}
                                        </div>
                                    </div>
                                    <div className="networks-oak">
                                        <div className="bedark-per">
                                            <div className="fungous-oaf">
                                                <input
                                                    id="tds-tax"
                                                    type="radio"
                                                    value="tds"
                                                    checked={taxtype === "tds"}
                                                    onChange={e => setTaxtype(e.target.value)}
                                                />
                                                <label htmlFor="tds-tax">TDS</label>
                                            </div>
                                            <div className="fungous-oaf">
                                                <input
                                                    id="tcs-tax"
                                                    type="radio"
                                                    value="tcs"
                                                    checked={taxtype === "tcs"}
                                                    onChange={e => setTaxtype(e.target.value)}
                                                />
                                                <label htmlFor="tcs-tax">TCS</label>
                                            </div>
                                        </div>
                                        <div className="sooty-few icing-bit">
                                            <div className="stopt-gnu" onClick={() => setTaxInputOpen(prev => !prev)}>
                                                <span>{selectedTax ? selectedTax.name : "Select a Tax"}</span>
                                                <IoChevronDownSharp />

                                                {taxInputOpen ? <div onClick={e => e.stopPropagation()} className="chimeras-time cirrus-tee">
                                                    <input
                                                        value={taxSearchInput}
                                                        onChange={e => setTaxSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                    />
                                                    <div className="pullmans-tom">
                                                        {filteredTaxList.length ? (
                                                            filteredTaxList.map((tax, taxIndex) => {
                                                                return (
                                                                    <div key={taxIndex} className="poetise-row" onClick={() => {
                                                                        setSelectedTax(tax)
                                                                        setTaxInputOpen(false)
                                                                    }}>
                                                                        <div className="winked-flit">
                                                                            {tax.name}
                                                                        </div>
                                                                        <div className="wights-spar">
                                                                            <AiOutlineMail /> {tax.tax.section}
                                                                        </div>
                                                                        <div className="grifting-dew">
                                                                            {tax.rate}%
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        ) : (
                                                            <div className="toffies-kook">
                                                                No results found
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="knife-labs" onClick={() => setAddManageTaxPopup(true)}>
                                                        <IoMdSettings />
                                                        <span>Manage {taxtype.toUpperCase()}</span>
                                                    </div>
                                                </div> : undefined}
                                            </div>
                                            {selectedTax ? <div onClick={() => setSelectedTax(undefined)} className="fecal-aha">Remove</div> : undefined}
                                        </div>
                                        <div>
                                            {(Math.round(calculatedTax * 100) / 100).toFixed(2)}
                                        </div>
                                    </div>
                                    <div className="mulling-guy networks-oak">
                                        <div>
                                            Total
                                        </div>
                                        <div className="icing-bit">

                                        </div>
                                        <div>
                                            ₹ {(Math.round(totalAmount * 100) / 100).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footrot-pip">
                            <button style={{ width: "100px" }} className="ballroom-tab" onClick={() => signature ? handleCreateInvoice() : setSigncanvas(true)}>
                                {loading === "create-invoice" ? <SpinnerCircular size="18" color="white" /> : "Save"}
                            </button>
                            <button style={{ width: "178px" }} className="ballroom-tab" onClick={() => signature ? handleCreateInvoice(true) : setSigncanvas(true)}>
                                {loading === "send-invoice" ? <SpinnerCircular size="18" color="white" /> : "Save and Send"}
                            </button>
                            <button className="satin-net">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    )
}

export default CreateInvoiceExternal
